<div>
	<div
		[matMenuTriggerFor]="menu"
		class="flex items-center gap-0.5 cursor-pointer"
	>
		<app-user-avatar
			[size]="size"
			class="rounded-circle"
		></app-user-avatar>
		<mat-icon
			*ngIf="!disableMenu"
			class="!text-xl"
			>expand_more</mat-icon
		>
	</div>
	<mat-menu
		[overlapTrigger]="true"
		#menu="matMenu"
		class="mat-menu-nopad usermenu-panel"
	>
		<div
			(click)="$event.stopPropagation()"
			class="flex flex-col items-stretch justify-start"
		>
			<div
				*ngIf="{ title: userTitle$ | async } as user"
				class="userinfo-section flex flex-col items-center"
			>
				<a
					[matTooltipEnabled]="!!user?.title"
					[matTooltipTemplate]="userTitleTemplate"
					[matTooltipTemplateContext]="{ title: user?.title }"
					class="my-4"
					href="https://portal.office.com/account/#personalinfo"
					matTooltip
					target="_blank"
				>
					<app-user-avatar
						class="rounded-circle mat-elevation-z4 flex-shrink-0"
						size="64px"
					></app-user-avatar>
				</a>
				<div class="flex flex-col items-center justify-center text-center">
					<span>{{ name$ | async }}</span>
					<small class="mat-hint">{{ this.currentWorkspace.name }}</small>
				</div>
			</div>
			<div class="my-2">
				<div class="mat-divider"></div>
			</div>
			<mat-list
				class="pt-0 space-y-1 px-2 [&_.mat-list-item]:rounded-lg"
				dense
			>
				<a
					[routerLink]="['/account', 'profile']"
					class="cursor-pointer"
					mat-list-item
					mat-ripple
				>
					<div class="flex items-center gap-2">
						<mat-icon class="flex-shrink-0">person_outline</mat-icon>
						<span>{{ 'account.profile._' | translate }}</span>
					</div>
				</a>
				<mat-list-item
					(click)="openCurrentWorkspaceCheckout()"
					*ngIf="(status$ | async).isExpired"
					class="cursor-pointer"
					mat-ripple
				>
					<div class="flex items-center gap-2">
						<mat-icon class="flex-shrink-0">shopping_cart</mat-icon>
						<span>{{ 'user.buy-license' | translate }}</span>
					</div>
				</mat-list-item>

				<mat-list-item
					class="cursor-pointer"
					mat-ripple
					teams-hide
				>
					<a
						[href]="meta.teams"
						class="flex items-center gap-2"
					>
						<mat-icon
							class="flex-shrink-0"
							svgIcon="ms_teams"
						></mat-icon>
						<span>{{ 'user.openTeamsApp' | translate }}</span>
					</a>
				</mat-list-item>
				<!-- <mat-list-item
					(click)="openFeedback()"
					mat-ripple
					class="cursor-pointer">
					{{ 'Feedback' | translate }}
				</mat-list-item> -->
				<a
					href="https://portal.office.com/account/#personalinfo"
					mat-list-item
					mat-ripple
					target="_blank"
				>
					<div class="flex items-center gap-2">
						<mat-icon class="flex-shrink-0">manage_accounts</mat-icon>
						<span>{{ 'user.office.manageprofile' | translate }}</span>
					</div>
				</a>
				<a
					*canAccessBeta
					href="https://web-beta.timeghost.io"
					mat-list-item
					mat-ripple
					target="_blank"
					teams-hide
				>
					<div class="flex items-center gap-2">
						<mat-icon class="flex-shrink-0">science</mat-icon>
						<span>{{ 'user.trybeta' | translate }}</span>
					</div>
				</a>
				<mat-list-item
					(click)="logout()"
					class="cursor-pointer"
					mat-ripple
				>
					<div class="flex items-center gap-2">
						<mat-icon class="flex-shrink-0">logout</mat-icon>
						<span>{{ 'LogOut' | translate }}</span>
					</div>
				</mat-list-item>
			</mat-list>
			<div class="mb-0 mt-2">
				<div class="mat-divider"></div>
			</div>
			<div class="flex flex-col p-2">
				<small class="mat-hint text-center">
					{{ this.releaseName || this.packageVersion }}
					<span
						*isBeta
						class="ml-1"
						>(Beta)</span
					>
				</small>
			</div>
		</div>
	</mat-menu>
</div>
<ng-template
	#userTitleTemplate
	let-title="title"
>
	<div class="flex items-center space-x-2 font-bold">
		<mat-icon inset>person</mat-icon>
		<div>{{ title }}</div>
	</div>
</ng-template>
